var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, Watch, PropertyConverters, Utils } from '@pacem/pacem-core';
import { TAG_MIDDLE_NAME } from '../constants';
import { KnownShader, MaterialElement } from './material';
//namespace Pacem.Components.Drawing3D {
let LambertMaterialElement = class LambertMaterialElement extends MaterialElement {
    constructor() {
        super(KnownShader.Lambert);
    }
    async createMaterial() {
        return Utils.extend({
            emissiveColor: this.emissiveColor || '#000',
            reflectivity: this.reflectivity ?? 0,
            refractionRatio: this.refractionRatio ?? 0
        }, await super.createMaterial());
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'emissiveColor':
                case 'reflectivity':
                case 'refractionRatio':
                    this.updateMaterial();
                    break;
            }
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], LambertMaterialElement.prototype, "emissiveColor", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], LambertMaterialElement.prototype, "reflectivity", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], LambertMaterialElement.prototype, "refractionRatio", void 0);
LambertMaterialElement = __decorate([
    CustomElement({ tagName: `${P}-${TAG_MIDDLE_NAME}-material-lambert` })
], LambertMaterialElement);
export { LambertMaterialElement };
